import { wordpressApi } from "./api";

export const WORDPRESS_CATEGORY_API = `${wordpressApi}/categories?per_page=100`;
